/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

import Article from "./../services/article";

const MUTATIONS = {
  SET_FEATURED: "setFeatured"
};

export default {
  namespaced: true,
  state: {
    featured: null
  },
  getters: {
    featured: state => state.featured
  },
  mutations: {
    [MUTATIONS.SET_FEATURED]: (state, featured) => {
      state.featured = featured;
    }
  },
  actions: {
    async load({ commit }) {
      let list = await Article.getByTag("featured");
      commit(MUTATIONS.SET_FEATURED, list);
      return list;
    }
  }
};
